import styled, { css } from 'styled-components';
import { TRANSITION_SETTINGS, LIST_GAP } from '../config.js';
import { themeGet } from '../../../foundation/theme/themeGet/get.js';

var GapFix = styled.div.withConfig({
  displayName: "GapFix",
  componentId: "sc-1omxegn-0"
})(["flex-shrink:0;height:0;width:100%;"]);
var SidebarMenuCollapsibleChildrenContainer = styled.div.withConfig({
  displayName: "SidebarMenuCollapsibleChildrenContainer",
  componentId: "sc-1omxegn-1"
})(["display:flex;flex-direction:column;gap:", ";overflow:hidden;opacity:0;max-height:0;transition:all ", ";", ""], themeGet('spacing.sm'), TRANSITION_SETTINGS, function (props) {
  return props.$open && "\n    opacity: 1;\n  ";
});
function animateMenu(state) {
  switch (state) {
    case 'hidden':
      return css(["display:none;opacity:0;transform:translate(0,-1rem);"]);
    case 'entering':
    case 'leaving':
      return css(["display:flex;opacity:0;transform:translate(0,-1rem);"]);
    default:
      return css(["display:flex;opacity:1;transform:translate(0,0);"]);
  }
}
var MenuContainer = styled.div.withConfig({
  displayName: "MenuContainer",
  componentId: "sc-1omxegn-2"
})(["z-index:1000;flex-direction:column;position:relative;max-height:100vh;overflow-y:auto;padding:", ";border-radius:", ";background-color:", ";box-shadow:", ";transition:all ", ";", ";"], themeGet('spacing.md'), themeGet('borderRadius.md'), themeGet('colors.background.50'), themeGet('dropShadow.300'), TRANSITION_SETTINGS, function (props) {
  return animateMenu(props.$state);
});
var MenuList = styled.div.withConfig({
  displayName: "MenuList",
  componentId: "sc-1omxegn-3"
})(["display:flex;flex-direction:column;gap:", ";"], LIST_GAP);

export { GapFix, MenuContainer, MenuList, SidebarMenuCollapsibleChildrenContainer };
